module.exports = __webpack_public_path__ + "img/fond_contact.dfa71b29.jpg";